import { type PublicGlobalConfig } from '../../global-config'
import { LOCALE } from '../../i18n'

/**
 * Don't use this map, provide mapping directly in related URL resolver function,
 * example {@link urlResolverGetAgb}. This map will be refactored.
 */
const urlMap: Record<LOCALE, Record<string, string>> = {
  [LOCALE.DE_AT]: {
    appLandingPage: '/lp/shop-apotheke-app/',
    newsletterPage: '/nx/newsletter/',
    ownBrandsLandingPage: '/produkte-redcare/',
    privacySecurityCreditCheck: '/datenschutz.htm#bonitaet',
  },
  [LOCALE.DE_CH]: {
    appLandingPage: '/lp/redcare-apotheke-app/',
    newsletterPage: '/nx/newsletter/',
    ownBrandsLandingPage: '/sale-6/',
  },
  [LOCALE.DE_DE]: {
    appLandingPage: '/lp/shop-apotheke-app/',
    newsletterPage: '/nx/newsletter/',
    ownBrandsLandingPage: '/healthydeals-redcare/',
    privacySecurityCreditCheck: '/datenschutz.htm#bonitaet',
  },
  [LOCALE.FR_BE]: {
    privacySecurityCreditCheck: '/fr/protection-des-donnees.htm',
  },
  [LOCALE.FR_CH]: {
    appLandingPage: '/lp/redcare-apotheke-app/',
    newsletterPage: '/nx/newsletter/',
    ownBrandsLandingPage: '/soldes-6/',
  },
  [LOCALE.FR_FR]: {
    appLandingPage: '/lp/appli-redcare-pharmacie/',
    newsletterPage: '/nx/newsletter/',
    ownBrandsLandingPage: '/specials10/',
    privacySecurityCreditCheck: '/protection-des-donnees.htm',
  },
  [LOCALE.IT_IT]: {
    appLandingPage: '/lp/redcare-app/',
    newsletterPage: '/nx/newsletter/',
    ownBrandsLandingPage: '/speciale-13/',
    privacySecurityCreditCheck: '/politica-protezione-dati-personali.htm',
  },
  [LOCALE.NL_BE]: {
    privacySecurityCreditCheck: '/nl/gegevensbescherming.htm#bonitaet',
  },
}

export const getUrlFromUrlMap = (
  globalConfig: Pick<PublicGlobalConfig, 'locale'>,
  pageKey: string,
): string => {
  return urlMap[globalConfig.locale][pageKey]
}
